import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateTransformOptions } from '@core/enums/date-transform-options.enum';
import { LocaleService } from '@selfcare/cms';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/nl';

@Pipe({
  name: 'scDynamicDateTemplate',
  standalone: true,
})
export class DynamicDateTemplatePipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);

  transform(text: string, option: DateTransformOptions = DateTransformOptions.CurrentDate): string {
    return text.replace(/\*.+\*/, (str) => {
      str = str.replace(/\*/g, '');

      const locale = this.localeService.currentLocale;

      const monthInWords = dayjs()
        .locale(locale)
        .format('MMMM');
      const subMonth = str.replace(/\(month\)/, monthInWords);

      let date = dayjs().format('DD-MM-YYYY');

      switch (option) {
        case DateTransformOptions.CurrentDate:
          date = dayjs().format('DD-MM-YYYY');
          break;
        case DateTransformOptions.ToTheEndOfMonth:
          date = dayjs().endOf('month').format('DD-MM-YYYY');
          break;
        case DateTransformOptions.OneCalendarMonth:
          date = dayjs().add(1, 'month').format('DD-MM-YYYY');
          break;
      }

      const subDate = subMonth.replace(/DD-MM-YYYY/, date);

      return subDate;
    });
  }
}
